import { render, staticRenderFns } from "./tree-menu.vue?vue&type=template&id=58a9486b&"
import script from "./tree-menu.vue?vue&type=script&lang=js&"
export * from "./tree-menu.vue?vue&type=script&lang=js&"
import style0 from "./tree-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a9486b')) {
      api.createRecord('58a9486b', component.options)
    } else {
      api.reload('58a9486b', component.options)
    }
    module.hot.accept("./tree-menu.vue?vue&type=template&id=58a9486b&", function () {
      api.rerender('58a9486b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/header/tree-menu.vue"
export default component.exports